import type { ReactNode } from 'react';
import * as Sentry from '@sentry/react';

import Error from '@/shared/ui/error/Error';

type AppErrorBoundaryProps = {
  boundaryId: string;
  children: ReactNode;
  onReset?: (error: unknown, componentStack: string, eventId: string) => void;
};

export function AppErrorBoundary({ boundaryId, children, onReset }: AppErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => scope.setTag('error_boundary', boundaryId)}
      onReset={onReset}
      fallback={({ resetError }) => <Error resetError={resetError} />}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
